import React from 'react'
import type { Icon } from 'shared/utils'

const FaqQuestion = (props: Icon) => {
    const {
        color = 'black',
        width = 164,
        height = 165,
        className = 'faq-question'
    } = props
    return (
        <svg width={width} height={height} fill={color} className={className}>
            <g fillRule="evenodd" opacity={0.2}>
                <path d="M81 88c2.765 0 5 2.24 5 5s-2.235 5-5 5c-2.76 0-5-2.24-5-5s2.24-5 5-5zm.192-5c-2.786 0-5.048-2.281-5.048-5.092 0-6.778 5.942-11.937 11.752-16.093 1.807-1.293 3.8-5.576 2.685-9.09-1.105-3.467-5.477-5.535-9.066-5.535h-.005c-3.937 0-8.823 1.849-10.726 7.022-.97 2.638-3.882 3.978-6.492 3-2.615-.978-3.947-3.911-2.973-6.549C64.373 42.367 72.298 37 81.51 37h.01c7.29 0 16.047 4.329 18.682 12.609 2.545 8-1.373 16.876-6.46 20.512-6.77 4.838-7.502 7.058-7.502 7.787 0 2.81-2.261 5.092-5.048 5.092z" />
                <path d="M66.3 11.116c-30.944 0-56.112 25.154-56.112 56.076 0 21.723 12.867 41.7 32.778 50.904a5.08 5.08 0 0 1 2.904 5.34l-3.296 23.088 26.498-22.074a5.113 5.113 0 0 1 3.26-1.176H96.7c30.94 0 56.113-25.154 56.113-56.082 0-30.927-25.173-56.076-56.113-56.076H66.3zM35.658 164c-.85 0-1.707-.214-2.48-.647a5.085 5.085 0 0 1-2.558-5.167l4.656-32.556C13.723 114.136 0 91.598 0 67.192 0 30.66 29.743.934 66.3.934h30.404C133.257.934 163 30.66 163 67.192c0 36.533-29.743 66.264-66.3 66.264H74.175l-35.26 29.364a5.058 5.058 0 0 1-3.26 1.181z" />
            </g>
        </svg>
    )
}

export { FaqQuestion }
